// @flow

// Hocs
import loginComponent from '../shared/Login'

// Components
import { Errors } from 'hfty-components-errors'
import Textfield from '@react-mdc/textfield'
import FormField from '@react-mdc/form-field'
import Button from '@react-mdc/button'
import { Link } from 'react-router-dom'
import { FormattedMessage } from 'react-intl'

// Libs
import React, { Component } from 'react'
import Spinner from 'react-spinkit'

// Constants
import { SUPPORT_PHONE_NUMBER, FE_LABS_URL } from 'hfty'

// Images
import logoImg from 'hfty-images/src/FE_Soils_Logo_WhiteBg.png'

// Messages
import messages from '../messages'

// Styles
import { primary, white, dark } from 'hfty-styles/src/colors'

const styles = {
  container: {
    flex: '1 1 auto',
    display: 'flex',
    backgroundColor: '#fafafa',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#333',
    flexDirection: 'column',
    marginTop: '4.4rem',
  },
  component: {
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'column',
    width: '100%',
  },
  banner: {
    display: 'block',
    background: primary(),
    position: 'absolute',
    top: 0,
    left: 0,
    height: '4.4rem',
    width: '100%',
  },
  logo: {
    display: 'block',
    margin: 'auto',
    height: '3rem',
    position: 'relative',
    top: '18%',
  },
  powered_by: {
    position: 'absolute',
    right: 5,
    top: '18%',
    height: '2.5rem',
  },
  form: {
    maxWidth: 450,
    width: '80%',
    margin: '0 auto 5px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    color: '#ffffff',
    backgroundColor: white(),
    padding: 20,
    boxShadow: '0 0 3px rgba(0,0,0,0.3)',
    marginBottom: 20,
  },
  span: {
    display: 'inline-flex',
    marginTop: 10,
  },
  mobileSpan: {
    display: 'inline-flex',
    marginTop: 10,
    flexDirection: 'column',
    textAlign: 'center',
  },
  divSpace: {
    marginLeft: 5,
    cursor: 'pointer',
    color: primary(),
  },
  mobileDiv: {},
  regDiv: {
    marginLeft: 5,
  },
  outerDiv: {
    display: 'flex',
  },
  spinnerDiv: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  loginHeader: {
    textAlign: 'center',
    width: '80%',
    height: '100px',
  },
  loginHeaderp1: {
    color: primary(),
    fontSize: '32px',
    fontWeight: 700,
  },
  loginHeaderp2: {
    color: dark(),
    fontSize: '18px',
    fontWeight: 600,
  },
  formField: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}

// Local Types
type Props = {
  isAuthenticated: boolean,
  isSubmitting: boolean,
  username: string,
  password: string,
  onChangeUsername: Function,
  onChangePassword: Function,
  onSubmit: Function,
  onLogout: Function,
  errors: BadResponses,
  mobile: boolean,
}

// Exports
export class Login extends Component {
  props: Props

  onChange(callback: Function): (e: Event & { currentTarget: HTMLInputElement }) => void {
    return (e: Event & { currentTarget: HTMLInputElement }) => {
      callback(e.currentTarget.value)
    }
  }

  render(): ?React.Element<any> {
    let mobile = this.props.mobile

    if (this.props.isAuthenticated) {
      return (
        <div>
          <div>Welcome {this.props.username}</div>
          <button onClick={this.props.onLogout}>Logout</button>
        </div>
      )
    } else if (this.props.isSubmitting) {
      return (
        <div style={styles.spinnerDiv}>
          <Spinner name="three-bounce" />
        </div>
      )
    } else {
      return (
        <div style={styles.container}>
          <div style={styles.component}>
            <div style={styles.banner}>
              <img src={logoImg} style={styles.logo} />
            </div>
            <form
              style={styles.form}
              onSubmit={(e: *): * => {
                e.preventDefault()
                this.props.onSubmit()
              }}
            >
              <div style={styles.loginHeader}>
                <p style={styles.loginHeaderp1}>
                  <FormattedMessage {...messages['Login']} />
                </p>
                <p style={styles.loginHeaderp2}>
                  <FormattedMessage {...messages['welcomeBack']} />
                </p>
              </div>
              <Errors errors={this.props.errors} messages={messages} />
              <FormField style={styles.formField}>
                <Textfield style={{ width: '80%' }}>
                  <Textfield.Label htmlFor="username">
                    <FormattedMessage {...messages['Username']} />
                  </Textfield.Label>
                  <Textfield.Input
                    id={'username'}
                    value={this.props.username}
                    onChange={this.onChange(this.props.onChangeUsername)}
                    required
                  />
                </Textfield>
              </FormField>
              <FormField style={styles.formField}>
                <Textfield style={{ width: '80%' }}>
                  <Textfield.Label htmlFor="password">
                    <FormattedMessage {...messages['Password']} />
                  </Textfield.Label>
                  <Textfield.Input
                    id={'password'}
                    type="password"
                    value={this.props.password}
                    onChange={this.onChange(this.props.onChangePassword)}
                    required
                  />
                </Textfield>
              </FormField>
              <span
                style={{
                  ...styles.span,
                  fontSize: '12px',
                  paddingBottom: '15px',
                  display: 'flex',
                  width: '80%',
                  justifyContent: 'flex-end',
                }}
              >
                <Link style={styles.divSpace} to={'/forgotpassword'}>
                  <FormattedMessage {...messages['forgotPassword']} />
                </Link>
              </span>
              <Button raised primary style={{ width: '35%' }}>
                <FormattedMessage {...messages['Login']} />
              </Button>
            </form>
          </div>
          {/* <span style={mobile ? styles.mobileSpan : styles.span}>
            <div><FormattedMessage {...messages['existingAgPhdUser']} /> </div>
            <div style={styles.outerDiv}>
              <div style={mobile ? styles.mobileDiv : styles.regDiv}>
                <Link to='/migrate'><FormattedMessage {...messages['migrateAction']} /></Link>
              </div>
            </div>
          </span> */}
          <span style={mobile ? styles.mobileSpan : styles.span}>
            <div>
              <FormattedMessage {...messages['noAccount']} />
            </div>
            <div style={styles.outerDiv}>
              <div style={mobile ? styles.mobileDiv : styles.regDiv}>
                <FormattedMessage {...messages['createAccount']} />
              </div>
              <Link style={styles.divSpace} to={'/registration'}>
                {'New Account'}
              </Link>
            </div>
          </span>
          <span style={{ ...styles.span, fontWeight: 500 }}>
            <FormattedMessage {...messages['needHelp']} /> {SUPPORT_PHONE_NUMBER}
          </span>
          <span style={styles.span}>
            <a style={styles.divSpace} href={FE_LABS_URL} target="_blank" rel="noopener noreferrer">
              <FormattedMessage {...messages['feLabs']} />
            </a>
          </span>
          <span style={styles.span}>
            <Link to={'/privacy-policy'} style={styles.divSpace}>
              <FormattedMessage {...messages['privacyPolicy']} />
            </Link>
          </span>
        </div>
      )
    }
  }
}

export default loginComponent(Login)
